//Types
export const Types = {
  GET_DRIVERS: "GET_DRIVERS",
  GET_DRIVER: "GET_DRIVER",
  CREATE_DRIVERS: "CREATE_DRIVERS",
  UPDATE_DRIVERS: "UPDATE_DRIVERS",
  DELETE_DRIVERS: "DELETE_DRIVERS",
  UPLOAD_DRIVER_FILE: "UPLOAD_DRIVER_FILE",
  DELETE_DRIVER_FILE: "DELETE_DRIVER_FILE",
  SET_LOADING: "SET_LOADING_DRIVERS",
}

//Reducer
const initialState = {
  drivers: null,
  driver: null,
  driverFile: null,

  loading: false,
}

const Drivers = (state = initialState, action) => {
  switch (action.type) {
    case Types.GET_DRIVERS:
      return {
        ...state,
        drivers: action.payload,
        loading: false,
      }
    case Types.GET_DRIVER:
      return {
        ...state,
        driver: action.payload,
        loading: false,
      }
    case Types.CREATE_DRIVERS:
      return {
        ...state,
        driver: action.payload,
        loading: false,
      }
    case Types.UPDATE_DRIVERS:
      return {
        ...state,
        driver: action.payload,
        loading: false,
      }
    case Types.DELETE_DRIVERS:
      return {
        ...state,
        loading: false,
      }
    case Types.UPLOAD_DRIVER_FILE:
      return {
        ...state,
        driverFile: action.payload,
      }
    case Types.DELETE_DRIVER_FILE:
      return {
        ...state,
        driverFile: null,
      }
    case Types.SET_LOADING:
      return {
        ...state,
        loading: true,
      }

    default:
      return state;
  }
}

export default Drivers;
